import { useContext } from "react"
import { AssessmentResultsTrackingContext } from "../AssessmentResultsTrackingContext"
import { Add } from "@mui/icons-material"

const useSegmentationFilter = () => {
    const { setSegmentation, segmentation } = useContext(AssessmentResultsTrackingContext)

    return {
        fullWidth: true,
        name: "segmentation",
        input: {
            value: segmentation,
            onChange: setSegmentation
        },
        popupIcon: <Add fontSize="small"/>,
        placeholder: "הוספת פילוח",
        options: [
            { id: 'gender', name: "בנים + בנות" },
            { id: 'immigrants', name: "עולים + ישראלים" },
        ]
    }
}

export default useSegmentationFilter